import script from "./WCProductCardBadgesModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCProductCardBadgesModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCProductCardBadgesModern.vue?vue&type=style&index=0&id=27aeccaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27aeccaa"]])

export default __exports__